import AuthApi from '@apis/auth/AuthApi';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useFlow } from '@router/stackflow';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useState } from 'react';
import { useCookies } from 'react-cookie';

function useWithdraw() {
  const [checked, setChecked] = useState(false);
  const toast = useToast();
  const { pop } = useFlow();
  const [cookies, _, removeCookies] = useCookies(['accessToken', 'refreshToken']);
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: AuthApi.withdraw,
    onSuccess() {
      toast.info('회원 탈퇴가 완료되었습니다.');
      queryClient.clear();
      removeCookies('accessToken', { path: '/' });
      removeCookies('refreshToken', { path: '/' });
      pop(3);
    },
    onError(e: AxiosError<ErrorResponse>) {
      toast.error(e.response?.data.message || '회원 탈퇴에 실패했습니다.');
    },
  });
  const handleWithdraw = () => {
    const { refreshToken } = cookies;
    if (!refreshToken) {
      toast.error('잘못된 접근입니다.');
      return;
    }
    mutate(refreshToken);
  };

  return {
    checked, setChecked, handleWithdraw,
  };
}

export default useWithdraw;
